import { Trans } from "@lingui/macro";
import { IApiEpBillingBill, IApiEpBillingRecurringPayment } from "@smp/api";
import { UiBox, UiButton, UiTypography } from "@smp/ui";
import { useCallback, useLayoutEffect, useRef } from "react";

import { useWindowOpener } from "@/hooks/use_window_opener";

export const Paypal = ({
  bill,
  onClose,
  onReachGoal,
  recurringPayment,
}: {
  bill?: IApiEpBillingBill;
  onClose: (fireSuccessAction?: boolean) => void;
  onReachGoal: () => void;
  recurringPayment?: IApiEpBillingRecurringPayment;
}) => {
  const isGoalReached = useRef(false);

  const url = bill
    ? bill.extra.paypal_order_approve_url
    : recurringPayment
    ? recurringPayment.confirm_url
    : undefined;

  const { isOpen, open } = useWindowOpener(
    {
      url,
    },
    {
      onClose: () => {
        if (!isGoalReached.current) {
          onClose();
        }
      },
    },
  );

  const handleOpen = useCallback(() => {
    isGoalReached.current = true;
    onReachGoal();
    open();
  }, [onReachGoal, open]);

  const handleMessage = useCallback<(e: MessageEvent<any>) => void>(
    (event) => {
      if (event.data?.type === "billing_success_page_open") {
        onClose(true);
      }
    },
    [onClose],
  );

  useLayoutEffect(() => {
    if (isOpen) {
      window.addEventListener("message", handleMessage);

      return () => window.removeEventListener("message", handleMessage);
    }
  }, [handleMessage, isOpen]);

  return isOpen ? (
    <UiBox>
      <UiBox>
        <UiTypography>
          <Trans>Payment in progress, do not close this window...</Trans>
        </UiTypography>
      </UiBox>
    </UiBox>
  ) : (
    <UiBox>
      <UiBox mb={2}>
        <UiTypography>
          <Trans>
            A payment invoice has been created, please proceed to payment.
          </Trans>
        </UiTypography>
      </UiBox>
      <UiBox>
        <UiButton color="primary" onClick={handleOpen} variant="contained">
          <Trans>Proceed</Trans>
        </UiButton>
      </UiBox>
    </UiBox>
  );
};
